import {
  VisibilityOutlined
} from "@mui/icons-material";
import AddSharpIcon from "@mui/icons-material/AddSharp";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ReplayIcon from '@mui/icons-material/Replay';
import SearchIcon from "@mui/icons-material/Search";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import {
  IconButton,
  Typography
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { DataGrid, GridColDef, GridRowId } from "@mui/x-data-grid";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Form, Modal, Spinner } from "react-bootstrap";
import { useHistory, useLocation, useParams } from "react-router";
import { Service } from "../../Service/ApiService";
import { CommonService } from "../../Service/CommonService";
import StatusDropdown from "../Common/StatusDropdown";
import "../Dynamic/UserList.scss";
import DeleteUser from "../popups/DeleteUser";
import InviteUser from "../popups/InviteUser";
import RestoreUser from "../popups/RestoreUser";
import SingleApprove from "../popups/SingleApprove";
import SingleReInvite from "../popups/SingleReInvite";
import SingleReject from "../popups/SingleReject";
import Constant from "../../Constant";
import { CookieService } from "../../Service/CookieService";
import notificationWebSocketService from "../../Websocket/notificationWebSocketService";
import LoginAsUserIcon from '../../assets/images/icons/LoginAsUser.svg';
import DataGridLoader from "../Common/DataGridLoader";

const UserList = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { id } = useParams<{ id: string }>();
  const [tableData, setTableData] = useState<any[]>([]);
  const [reviewUserCount, setReviewCount] = useState(0);
  const [search, setSearch] = useState("");
  let approved: any[] = [];
  const approvedUserRef = useRef(approved);
  const deletedUserRef = useRef(approved);
  let rejected: any[] = [];
  const rejectedUserRef = useRef(rejected);
  const disableAction = useRef(false);
  const isNeedReviewClicked = useRef(false);
  const selectedRows = useRef(approved);
  const [selectedRowsFromTable, setSelectedRowsFromTable] = useState<any[]>([]);
  const [selectionRowsFromTable, setSelectionRowsFromTable] = useState<any[]>([]);
  const history = useHistory();
  const [activeUserCount, setActiveUserCount] = useState(0);
  const [deleteUserCount, setDeleteUserCount] = useState(0);
  const [rejectedUsersCount, setRejectedUserCount] = useState(0);
  const isRejectedUserClicked = useRef(false);
  const isActiveUserClicked = useRef(false);
  const isDeletedUserClicked = useRef(false);

  const [forceOpen, setForceOpen] = useState(false);
  const [isSingleClickMode, setIsSingleClickMode] = useState(false);

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const controllerRef = useRef<AbortController | null>(null);
  const [sortField, setSortField] = useState("CreatedModifiedDate"); // Default sort
  const [sortDirection, setSortDirection] = useState("asc"); // Default ascending
  const [selectedUserId, setSelectedUserId] = useState(null);

  const [filter, setFilter] = useState<any>({
    firstName: null,
    email: null,
    roleName: null,
    phoneNumber: null,
    birthdate: null,
    ecommCompanyName: null,
    requestedBy: null,
    location: null,
    userStatus: null,
  });
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
  };
  const [toggleNotification, setToggleNotification] = useState(false);
  
    const handleNotificationToggle = (e) => {
        const newValue = e.target.checked;
        setToggleNotification(newValue);
        localStorage.setItem('showAssociatedCompany', newValue ? 'yes' : 'no');
      };

  const toTitleCase = (str: string) => {
    return str
      .replace(/_/g, " ") // Replace underscores with spaces
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
  };

  const reloadTable = () => {
    if (isActiveUserClicked.current) {
      fetchApprovedUserData(page, pageSize, filter, sortField, sortDirection);
      fetchDeleteUsersCount();
    } else if (isNeedReviewClicked.current) {
      showSubmittedAndInvitedUsers(true, page, pageSize, filter, sortField, sortDirection);
      fetchRejectedUsersCount();
      fetchActiveUsersCount();
    }else if (isDeletedUserClicked.current) {
      fetchDeletedUserData(page, pageSize, filter, sortField, sortDirection);
      fetchActiveUsersCount();
    } else {
      showRejectedUsers(true, page, pageSize, filter, sortField, sortDirection);
    }
  };

  const setOpenPopUp = () => {
    setIsSingleClickMode(false);
    setForceOpen(false);
  };

  const showSubmittedAndInvitedUsers = (
    isReload: boolean,
    page: any,
    size: any,
    filter: any,
    sortField: any, 
    sortDirection: any
  ) => {
    if (!isReload) {
      isNeedReviewClicked.current = !isNeedReviewClicked.current;
    }
    if (isNeedReviewClicked.current) {
      const controller = new AbortController();
      const signal = controller.signal;
      try {
        isActiveUserClicked.current = false;
        isRejectedUserClicked.current = false;
        isDeletedUserClicked.current = false;

        setIsLoading(true);
        setTableData([]);
        // Cancel the previous request if any
        if (controllerRef.current) {
          controllerRef.current.abort();
        }

        // Store the current controller to cancel the request if needed
        controllerRef.current = controller;

        Service.getSubmittedUsers(
          CommonService.isUser()
            ? CommonService.getCompanyId()
            : currentPath.includes("/master/my-warehouse/user-list")
            ? id
            : null,
          page,
          size,
          filter,
          sortField,
          sortDirection,
          signal
        )
          .then((response) => {
            let c: any = [];
            c = response.data.content;
            setTotalCount(response.data.totalElements);
            setTableData(c);
            setReviewCount(response.data.totalElements);
          })
          .catch((error) => {
            if (error.response?.status === 401) {
              // CommonService.unAuthorizedError();
            } else {
              // Process the response data
              //CommonService.Toast.fire({
              //icon: "error",
              //title: "error.response.data.error",
              //});
            }
          })
          .finally(() => {
            setIsLoading(false);
          });
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    } else {
      fetchApprovedUserData(page, pageSize, filter, sortField, sortDirection);
    }
  };

  const showActiveUsers = (isReload: boolean) => {
    //write the logic for show active users
    if (!isActiveUserClicked.current) {
      isRejectedUserClicked.current = false;
      isNeedReviewClicked.current = false;
      isActiveUserClicked.current = true;
      isDeletedUserClicked.current = false;
      fetchApprovedUserData(page, pageSize, filter, sortField, sortDirection);
    }
  };

  const showDeletedUsers = (isReload: boolean) => {
    //write the logic for show active users
    if (!isDeletedUserClicked.current) {
      isRejectedUserClicked.current = false;
      isNeedReviewClicked.current = false;
      isActiveUserClicked.current = false;
      isDeletedUserClicked.current = true;
      fetchDeletedUserData(page, pageSize, filter, sortField, sortDirection);
    }
  };

  const showRejectedUsers = (
    isReload: boolean,
    page: any,
    size: any,
    filter: any,
    sortField: any, 
    sortDirection: any
  ) => {
    if (!isReload) {
      isRejectedUserClicked.current = !isRejectedUserClicked.current;
    }
    if (isRejectedUserClicked.current) {
      const controller = new AbortController();
      const signal = controller.signal;
      try {
        isActiveUserClicked.current = false;
        isNeedReviewClicked.current = false;
        isDeletedUserClicked.current = false;
        setIsLoading(true);
        setTableData([]);
        // Cancel the previous request if any
        if (controllerRef.current) {
          controllerRef.current.abort();
        }

        // Store the current controller to cancel the request if needed
        controllerRef.current = controller;

        Service.getAllRejectedUsers(
          CommonService.isUser()
            ? CommonService.getCompanyId()
            : currentPath.includes("/master/my-warehouse/user-list")
            ? id
            : null,
          page,
          size,
          filter,
          sortField,
          sortDirection,
          signal
        )
          .then((response) => {
            let c: any = [];
            c = response.data[0].content;
            setTotalCount(response.data[0]?.totalElements);
            setTableData(c);
            setRejectedUserCount(response.data[0]?.totalElements);
          })
          .catch((error) => {
            console.log("error occurred while api calling");
          })
          .finally(() => {
            setIsLoading(false);
          });
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    } else {
      fetchApprovedUserData(page, pageSize, filter, sortField, sortDirection);
    }
  };

  //redirect to the add user page
  const handleAddUser = () => {
    if (CommonService.isAdmin()) history.push("/master/add-user");
    else history.push("/user/add-user");
  };

  const fetchApprovedUserData = async (page: any, size: any, filter: any, sortField: any, sortDirection: any) => {
    const controller = new AbortController();
    const signal = controller.signal;
    try {
      setIsLoading(true);
      setTableData([]);
      // Cancel the previous request if any
      if (controllerRef.current) {
        controllerRef.current.abort();
      }

      // Store the current controller to cancel the request if needed
      controllerRef.current = controller;
      isActiveUserClicked.current = true;

      const response = await Service.getAllApprovedUsers(
        CommonService.isUser()
          ? CommonService.getCompanyId()
          : currentPath.includes("/master/my-warehouse/user-list")
          ? id
          : null,
        page,
        size,
        filter,
        sortField, sortDirection,
        signal
      );
      approved = Object.values(response.data.content); // Convert object to array
      setTotalCount(response.data.totalElements);
      setActiveUserCount(response.data.totalElements);
      approvedUserRef.current = approved;
      // Access updated value of approvedUser using approvedUserRef.current
      if (approved) {
        setTableData(approvedUserRef.current);
      }
      Service.getSubmittedUsersCount(
        CommonService.isUser()
          ? CommonService.getCompanyId()
          : currentPath.includes("/master/my-warehouse/user-list")
          ? id
          : null
      ).then((response) => {
        setReviewCount(response.data);
      });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const fetchDeletedUserData = async (page: any, size: any, filter: any, sortField: any, sortDirection: any) => {
    const controller = new AbortController();
    const signal = controller.signal;
    try {
      setIsLoading(true);
      setTableData([]);
      // Cancel the previous request if any
      if (controllerRef.current) {
        controllerRef.current.abort();
      }

      // Store the current controller to cancel the request if needed
      controllerRef.current = controller;
      isDeletedUserClicked.current = true;

      const response = await Service.getAllDeletedUsers(
        CommonService.isUser()
          ? CommonService.getCompanyId()
          : currentPath.includes("/master/my-warehouse/user-list")
          ? id
          : null,
        page,
        size,
        filter,
        sortField,
        sortDirection,
        signal
      );
      approved = Object.values(response.data.content); // Convert object to array
      setTotalCount(response.data.totalElements);
      setDeleteUserCount(response.data.totalElements);
      deletedUserRef.current = approved;
      // Access updated value of approvedUser using approvedUserRef.current
      if (approved) {
        setTableData(deletedUserRef.current);
      }
      Service.getSubmittedUsersCount(
        CommonService.isUser()
          ? CommonService.getCompanyId()
          : currentPath.includes("/master/my-warehouse/user-list")
          ? id
          : null
      ).then((response) => {
        setReviewCount(response.data);
      });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const fetchActiveUsersCount = async () => {
    try {
      const response = await Service.getActiveUsersCount(
        CommonService.isUser()
          ? CommonService.getCompanyId()
          : currentPath.includes("/master/my-warehouse/user-list")
          ? id
          : null
      );
      setActiveUserCount(response.data);
    } catch (error) {
      console.error("Error fetching counts:", error);
    }
  };

  const fetchDeleteUsersCount = async () => {
    try {
      const response = await Service.getDeleteUsersCount(
        CommonService.isUser()
          ? CommonService.getCompanyId()
          : currentPath.includes("/master/my-warehouse/user-list")
          ? id
          : null
      );
      setDeleteUserCount(response.data);
    } catch (error) {
      console.error("Error fetching counts:", error);
    }
  };

  const fetchCompanyUserData = async () => {
    const response: any = await Service.fetchCompanyUserData(
      CommonService.isUser()
        ? CommonService.getCompanyId()
        : currentPath.includes("/master/my-warehouse/user-list")
        ? id
        : null
    );
    setTableData(response.data);
  };

  const fetchRejectedUsersCount = async () => {
    try {
      const response = await Service.getRejectedUsersCount(
        CommonService.isUser()
          ? CommonService.getCompanyId()
          : currentPath.includes("/master/my-warehouse/user-list")
          ? id
          : null
      );
      setRejectedUserCount(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleRestoreUser = () => {
    // setIsLoading(true);
    // if (deleteUser.length) {
    //     Service.removeUserProfile(deleteUser)
    //           .then(response => {
    //             setIsLoading(false);
    //             CommonService.Toast.fire({
    //               title: "User deleted successfully !",
    //               icon: 'success',
    //             });
    //             reloadTable();
    //           })
    //           .catch(error => {
    //             setIsLoading(false);
    //             console.log(error);
    //           });
    // }
    // setIsLoading(false);
    // handleClose();
  };

  useEffect(() => {
    // if (
    //   currentPath === "/master/my-warehouse/user-list/" + id ||
    //   currentPath === "/user/my-warehouse/user-list/" + id ||
    //   currentPath === "/user/user-list"
    // )
    // fetchCompanyUserData();
    fetchApprovedUserData(page, pageSize, filter, sortField, sortDirection);
    fetchRejectedUsersCount();
    fetchDeleteUsersCount();
  }, []);

  const handleVisibilityClick = (event: any, params: any) => {
    // Logic to handle the click event for Visibility button
    event.stopPropagation(); // Prevent event from bubbling up to the row
    CommonService.Toast.fire({
      title: "View icon clicked",
    });
  };

  //add tooltip
  const CellWithTooltip = ({ value }: { value: string | number }) => {
    return (
      <Tooltip arrow title={value?.toString()}>
        <span>{value?.toString()}</span>
      </Tooltip>
    );
  };

  const handleFilterChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
    field: keyof any
  ) => {
    const value = event.target.value;

    // Prepare a temporary filter object with the updated field value
    const tempFilter = {
      ...filter, // Spread existing filter state
      [field]:
        (field === "roleName" || field === "userStatus") && value === ""
          ? null
          : value, // Update field only if the condition is met
    };

    // Update the filter state
    setFilter(tempFilter);

    // Load the service requests with updated filters
    if (isActiveUserClicked.current) {
      fetchApprovedUserData(page, pageSize, tempFilter, sortField, sortDirection);
    } else if (isNeedReviewClicked.current) {
      showSubmittedAndInvitedUsers(true, page, pageSize, tempFilter, sortField, sortDirection);
    } else if (isDeletedUserClicked.current) {
      fetchDeletedUserData(page, pageSize, tempFilter, sortField, sortDirection);
    }else {
      showRejectedUsers(true, page, pageSize, tempFilter, sortField, sortDirection);
    }
  };

  const commonColumns: GridColDef[] = [
    {
      field: "firstName",
      headerName: "User",
      flex: 1,
      minWidth: 200,
      sortable: true,
      valueGetter: (value: any, row: any) => {
        const firstName = row.firstName || "";
        const lastName = row.lastName || "";
        return firstName || lastName ? `${firstName} ${lastName}` : "-";
      },
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <div className="position-relative" style={{ width: 170 }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              //value={filter.firstName}
              defaultValue={filter.firstName}
              onChange={(event) => handleFilterChange(event, "firstName")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div>
        </div>
      ),
      renderCell: (params: any) => <div>{params.value}</div>,
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      minWidth: 200,
      sortable: true,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <div className="position-relative" style={{ width: 170 }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              //value={filter.email}
              defaultValue={filter.email}
              onChange={(event) => handleFilterChange(event, "email")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div>
        </div>
      ),
      renderCell: (params) => <CellWithTooltip value={params.value || "-"} />,
    },
    {
      field: "roleName",
      headerName: "Role",
      flex: 1,
      minWidth: 200,
      sortable: true,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <>
          <div>
            <Typography
              variant="body2"
              sx={{ color: "#6F6F6F", fontSize: "14px" }}
            >
              {params.colDef.headerName}
            </Typography>
            <div className="position-relative" style={{ width: 170 }}>
              <Form.Select
                style={{
                  cursor: "pointer",
                  borderBottomColor: "#D1D1D1",
                  marginTop: "4px",
                }}
                value={filter.roleName}
                className="form-control mb-1"
                onChange={(event) => handleFilterChange(event, "roleName")}
                onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
              >
                <option value="">Select Role</option>
                {CommonService.isAdmin() && <option value="SUPER_ADMIN">Super Admin</option>}
                <option value="ADMIN">Admin</option>
                <option value="USER">User</option>
                {CommonService.isAdmin() && <option value="WAREHOUSE">Warehouse</option>}
              </Form.Select>
            </div>
          </div>
        </>
      ),
      renderCell: (params) => (
        <CellWithTooltip value={CommonService.formatRoleName(params.value)} />
      ),
    },
    {
      field: "phoneNumber",
      headerName: "Phone",
      flex: 1,
      minWidth: 200,
      sortable: true,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <div className="position-relative" style={{ width: 170 }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              //value={filter.phoneNumber}
              defaultValue={filter.phoneNumber}
              onChange={(event) => handleFilterChange(event, "phoneNumber")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div>
        </div>
      ),
      renderCell: (params) => <CellWithTooltip value={params.value || "-"} />,
    },
    {
      field: "birthdate",
      headerName: "Birth Date",
      flex: 1,
      minWidth: 200,
      sortable: true,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <input
            type="date"
            className="form-control border mt-1"
            style={{ boxShadow: "none" }}
            id="birthdate"
            name="birthdate"
            placeholder="MM/DD/YYYY"
            //value={filter.birthdate}
            defaultValue={filter.birthdate}
            onChange={(event) => handleFilterChange(event, "birthdate")}
            onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
          />
        </div>
      ),
      renderCell: (params) => <CellWithTooltip value={params.value || "-"} />,
      valueGetter: (value: any, row: any) => {
        const dateTime = row.birthdate ? new Date(row.birthdate) : null;

        // Format Date and time
        if (dateTime) {
          const options: any = {
            month: "short", // Abbreviated month name (e.g., "Jul")
            day: "numeric", // Day of the month (e.g., "16")
            year: "numeric", // Full year (e.g., "2024")
          };
          return dateTime.toLocaleString("en-US", options);
        } else {
          return "";
        }
      },
    },
    ...(CommonService.isAdmin()
      ? [
          {
            field: "ecommCompanyName",
            headerName: "Company Name",
            flex: 1,
            minWidth: 200,
            sortable: true,
            headerClassName: "table-header border-0 my-2 h-100",
            renderHeader: (params) => (
              <div>
                <Typography
                  variant="body2"
                  sx={{ color: "#6F6F6F", fontSize: "14px" }}
                >
                  {params.colDef.headerName}
                </Typography>
                <div className="position-relative" style={{ width: 170 }}>
                  <input
                    type="text"
                    className="form-control border mt-1"
                    style={{ textIndent: "24px", boxShadow: "none" }}
                    placeholder="Search"
                    //value={filter.ecommCompanyName}
                    defaultValue={filter.ecommCompanyName}
                    onChange={(event) =>
                      handleFilterChange(event, "ecommCompanyName")
                    }
                    onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                  />
                  <SearchIcon
                    sx={{
                      color: "#6F6F6F",
                      position: "absolute",
                      top: "50%",
                      left: "8px",
                      transform: "translateY(-50%)",
                    }}
                  />
                </div>
              </div>
            ),
            renderCell: (params) => (
              <CellWithTooltip value={params?.row?.ecommCompanyName || "-"} />
            ),
          },
        ]
      : []),
    {
      field: "requestedBy",
      //headerName: "Requested By",
      headerName: "Created By",
      flex: 1,
      minWidth: 200,
      sortable: true,
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <div className="position-relative" style={{ width: 170 }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              //value={filter.requestedBy}
              defaultValue={filter.requestedBy}
              onChange={(event) => handleFilterChange(event, "requestedBy")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div>
        </div>
      ),
      renderCell: (params) => (
        <CellWithTooltip value={params?.row?.requestedBy || "-"} />
      ),
    },
    {
      field: "lastLoggedIn",
      headerName: "Last Logged In",
      flex: 1,
      minWidth: 200,
      sortable: true,
      headerClassName: "table-header border-0 my-2 h-100",
      renderCell: (params: any) => <CellWithTooltip value={params.value || "-"} />,
      valueGetter: (value: any, row: any) => {
        const dateTimeString = row.lastLoggedIn ? row.lastLoggedIn : null;
        if (dateTimeString) {
          return CommonService.formatDateTime(dateTimeString);
        }
      },
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>

          <div className="position-relative" style={{ width: 170 }}>
            <input
              type="date"
              className="form-control border mt-1"
              style={{ boxShadow: "none" }}
              id="lastLoggedIn"
              name="lastLoggedIn"
              placeholder="MM/DD/YYYY"
              defaultValue={filter.lastLoggedIn}
              onChange={(event) => handleFilterChange(event, "lastLoggedIn")}
              onClick={(event) => event.stopPropagation()}
            />
          </div>
        </div>
      ),
    },
    {
      field: "location",
      headerName: "Location",
      flex: 1,
      minWidth: 200,
      sortable: true,
      valueGetter: (value: any, row: any) => {
        const city = row?.city;
        const state = row?.state;
        const zipcode = row?.zipcode;
        // Check if city exists and add comma
        const cityWithComma = city ? city + ", " : "";
        // Check if state exists and add space
        const stateWithSpace = state ? state + " " : "";
        return `${cityWithComma}${stateWithSpace}${zipcode || ""}`;
      },
      headerClassName: "table-header border-0 my-2 h-100",
      renderHeader: (params) => (
        <div>
          <Typography
            variant="body2"
            sx={{ color: "#6F6F6F", fontSize: "14px" }}
          >
            {params.colDef.headerName}
          </Typography>
          <div className="position-relative" style={{ width: 170 }}>
            <input
              type="text"
              className="form-control border mt-1"
              style={{ textIndent: "24px", boxShadow: "none" }}
              placeholder="Search"
              //value={filter.location}
              defaultValue={filter.location}
              onChange={(event) => handleFilterChange(event, "location")}
              onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
            />
            <SearchIcon
              sx={{
                color: "#6F6F6F",
                position: "absolute",
                top: "50%",
                left: "8px",
                transform: "translateY(-50%)",
              }}
            />
          </div>
        </div>
      ),
      renderCell: (params) => <CellWithTooltip value={params.value || "-"} />,
    },
    ...(isRejectedUserClicked.current || isNeedReviewClicked.current
      ? [
          {
            field: "userStatus",
            headerName: "Status",
            flex: 1,
            minWidth: 200,
            sortable: true,
            headerClassName: "table-header border-0 my-2 h-100",
            renderHeader: (params) => (
              <>
                <div>
                  <Typography
                    variant="body2"
                    sx={{ color: "#6F6F6F", fontSize: "14px" }}
                  >
                    {params.colDef.headerName}
                  </Typography>
                  <div className="position-relative" style={{ width: 170 }}>
                    <Form.Select
                      style={{
                        cursor: "pointer",
                        borderBottomColor: "#D1D1D1",
                        marginTop: "4px",
                      }}
                      value={filter.userStatus}
                      className="form-control mb-1"
                      onChange={(event) =>
                        handleFilterChange(event, "userStatus")
                      }
                      onClick={(event) => event.stopPropagation()} // Prevent event from bubbling up
                    >
                      <option value="">Select Status</option>
                      <option value="INVITED">Invited</option>
                      <option value="PENDING_REVIEW">Pending Review</option>
                      <option value="REJECTED">Rejected</option>
                    </Form.Select>
                  </div>
                </div>
              </>
            ),
            renderCell: (params) => (
              <div>
                <StatusDropdown
                  currentStatus={params.row.userStatus}
                  onStatusChange={(newStatus) => {}}
                  disableCondition={
                    CommonService.isUser() || CommonService.isAdmin()
                  }
                  allowedLabels={[]}
                />
                {params.row.userStatus === "REJECTED" && (
                  <Tooltip
                    title={`Rejection Note: ${params.row.rejectionNote}`}
                    arrow
                  >
                    <StickyNote2Icon
                      className="note-icon cursor-pointer"
                      style={{ color: "gray" }}
                    />
                  </Tooltip>
                )}
              </div>
            ),
          },
        ]
      : []),
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      width: 200,
      headerClassName: "table-header border-0 my-2 h-100",
      renderCell: (params: any) => (
        <div onClick={(e) => e.stopPropagation()}>
          {params.row.roleName !== Constant.Role.WAREHOUSE && isActiveUserClicked.current && !isDeletedUserClicked.current && !isRejectedUserClicked.current && !isNeedReviewClicked.current && (
          <Tooltip title="Manage Notification" arrow>
              <IconButton onClick={() => fetchWantedToBuyNotificationsToggleValue(params.row.id)}>
                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.8525 13.2272C15.4766 12.5837 14.9179 10.7629 14.9179 8.38485C14.9179 6.9567 14.3472 5.58704 13.3312 4.57719C12.3152 3.56733 10.9372 3 9.50034 3C8.0635 3 6.68551 3.56733 5.66951 4.57719C4.65352 5.58704 4.08274 6.9567 4.08274 8.38485C4.08274 10.7636 3.52337 12.5837 3.14752 13.2272C3.05154 13.3908 3.00066 13.5766 3.00001 13.766C2.99935 13.9554 3.04895 14.1416 3.1438 14.3058C3.23864 14.4701 3.37539 14.6065 3.54023 14.7015C3.70508 14.7965 3.89221 14.8465 4.08274 14.8467H6.84639C6.97138 15.4546 7.30379 16.0009 7.78738 16.3933C8.27098 16.7857 8.87608 17 9.50034 17C10.1246 17 10.7297 16.7857 11.2133 16.3933C11.6969 16.0009 12.0293 15.4546 12.1543 14.8467H14.9179C15.1084 14.8464 15.2955 14.7963 15.4602 14.7013C15.625 14.6062 15.7616 14.4698 15.8564 14.3055C15.9511 14.1413 16.0007 13.9551 16 13.7658C15.9993 13.5765 15.9484 13.3907 15.8525 13.2272ZM9.50034 15.9236C9.16432 15.9235 8.8366 15.8199 8.56228 15.6271C8.28796 15.4342 8.08052 15.1615 7.96851 14.8467H11.0322C10.9202 15.1615 10.7127 15.4342 10.4384 15.6271C10.1641 15.8199 9.83635 15.9235 9.50034 15.9236ZM4.08274 13.7697C4.60418 12.8785 5.16626 10.8134 5.16626 8.38485C5.16626 7.24233 5.62288 6.1466 6.43568 5.33872C7.24848 4.53083 8.35087 4.07697 9.50034 4.07697C10.6498 4.07697 11.7522 4.53083 12.565 5.33872C13.3778 6.1466 13.8344 7.24233 13.8344 8.38485C13.8344 10.8114 14.3951 12.8765 14.9179 13.7697H4.08274Z" fill="black"/>
                  <path d="M9.5003 8.00627C9.20365 8.00627 8.91366 8.08746 8.667 8.23957C8.42034 8.39169 8.2281 8.60789 8.11458 8.86084C8.00105 9.11379 7.97135 9.39214 8.02922 9.66067C8.0871 9.9292 8.22995 10.1759 8.43971 10.3695C8.64948 10.5631 8.91673 10.6949 9.20768 10.7483C9.49863 10.8017 9.80021 10.7743 10.0743 10.6696C10.3483 10.5648 10.5826 10.3873 10.7474 10.1597C10.9122 9.93204 11.0002 9.6644 11.0002 9.3906C10.9998 9.02357 10.8416 8.67168 10.5604 8.41215C10.2792 8.15262 9.89796 8.00665 9.5003 8.00627ZM9.5003 10.3135C9.30253 10.3135 9.1092 10.2594 8.94477 10.158C8.78033 10.0565 8.65216 9.91241 8.57648 9.74377C8.5008 9.57514 8.481 9.38958 8.51958 9.21055C8.55816 9.03153 8.6534 8.86709 8.79324 8.73802C8.93308 8.60895 9.11125 8.52106 9.30522 8.48545C9.49919 8.44984 9.70024 8.46811 9.88295 8.53797C10.0657 8.60782 10.2218 8.7261 10.3317 8.87787C10.4416 9.02964 10.5002 9.20807 10.5002 9.3906C10.5002 9.63537 10.3949 9.87011 10.2074 10.0432C10.0198 10.2163 9.76549 10.3135 9.5003 10.3135ZM12.9357 8.79101C12.9287 8.75852 12.9143 8.7278 12.8933 8.70092C12.8723 8.67405 12.8453 8.65166 12.8141 8.63528L11.882 8.14499L11.8783 7.17539C11.8781 7.14199 11.8702 7.10902 11.8549 7.07875C11.8396 7.04847 11.8174 7.02162 11.7898 7.00004C11.4517 6.73606 11.0623 6.53377 10.6424 6.40391C10.6093 6.39358 10.5743 6.38976 10.5395 6.39269C10.5048 6.39562 10.471 6.40524 10.4405 6.42093L9.5003 6.90602L8.55911 6.42006C8.5286 6.40428 8.49484 6.39459 8.46002 6.39161C8.42519 6.38863 8.39008 6.39243 8.35694 6.40276C7.93733 6.53356 7.5484 6.73663 7.21077 7.00119C7.1832 7.02274 7.16102 7.04955 7.14575 7.07977C7.13049 7.10999 7.1225 7.14291 7.12234 7.17625L7.11765 8.14672L6.18553 8.63701C6.15435 8.65339 6.12735 8.67578 6.10638 8.70266C6.0854 8.72953 6.07094 8.76025 6.06398 8.79274C5.97867 9.1884 5.97867 9.59569 6.06398 9.99134C6.07094 10.0238 6.0854 10.0546 6.10638 10.0814C6.12735 10.1083 6.15435 10.1307 6.18553 10.1471L7.11765 10.6374L7.1214 11.607C7.12152 11.6404 7.12948 11.6733 7.14475 11.7036C7.16002 11.7339 7.18223 11.7607 7.20984 11.7823C7.54796 12.0463 7.93733 12.2486 8.35725 12.3784C8.39032 12.3888 8.42537 12.3926 8.46014 12.3897C8.4949 12.3867 8.52862 12.3771 8.55911 12.3614L9.5003 11.8752L10.4415 12.3611C10.4787 12.3803 10.5207 12.3902 10.5633 12.39C10.5906 12.39 10.6178 12.3859 10.6437 12.3779C11.0632 12.2472 11.4521 12.0444 11.7898 11.78C11.8174 11.7585 11.8396 11.7317 11.8548 11.7014C11.8701 11.6712 11.8781 11.6383 11.8783 11.605L11.8829 10.6345L12.8151 10.1442C12.8462 10.1278 12.8732 10.1054 12.8942 10.0785C12.9152 10.0517 12.9296 10.0209 12.9366 9.98846C13.0214 9.59312 13.0211 9.18624 12.9357 8.79101ZM12.467 9.79782L11.5742 10.2665C11.5351 10.287 11.5027 10.3169 11.4805 10.353C11.4623 10.3818 11.4433 10.4124 11.4239 10.4412C11.3991 10.4776 11.3859 10.5197 11.3858 10.5627L11.3811 11.4928C11.1411 11.6667 10.8738 11.8058 10.5883 11.9052L9.68778 11.442C9.6504 11.4229 9.60833 11.413 9.5656 11.4132H9.55967C9.52186 11.4132 9.48373 11.4132 9.44592 11.4132C9.40121 11.4121 9.35699 11.4221 9.31781 11.442L8.41662 11.9063C8.13055 11.8077 7.86248 11.6693 7.62168 11.4959L7.61824 10.5673C7.61809 10.5242 7.60488 10.4821 7.58012 10.4456C7.56075 10.4167 7.54169 10.3879 7.52388 10.3573C7.50179 10.3207 7.46941 10.2902 7.43013 10.2691L6.53645 9.79927C6.4902 9.52927 6.4902 9.25424 6.53645 8.98424L7.42763 8.51472C7.46675 8.4942 7.49913 8.4643 7.52138 8.4282C7.5395 8.39936 7.55856 8.36879 7.57793 8.33995C7.60273 8.30358 7.61594 8.26151 7.61606 8.21854L7.62074 7.28844C7.8607 7.11452 8.12804 6.97544 8.4135 6.87602L9.31281 7.3392C9.35195 7.35922 9.39619 7.36918 9.44093 7.36804C9.47873 7.36804 9.51686 7.36804 9.55467 7.36804C9.59939 7.36907 9.6436 7.35912 9.68278 7.3392L10.584 6.87487C10.87 6.97353 11.1381 7.11192 11.3789 7.28527L11.3823 8.21392C11.3825 8.25698 11.3957 8.29914 11.4205 8.33563C11.4398 8.36447 11.4589 8.39331 11.4767 8.42388C11.4988 8.46054 11.5312 8.49102 11.5705 8.51213L12.4641 8.98194C12.511 9.25214 12.5128 9.52747 12.467 9.79782Z" fill="black"/>
                </svg>
              </IconButton>
            </Tooltip>
          )}
          {isDeletedUserClicked.current && CommonService.isAdmin() && params.row.isCompanyDeleted && (
            <Tooltip title="Restore User" arrow>
              <IconButton onClick={() => handleRowClick(params)}>
                <ReplayIcon sx={{ transform: "rotate(-45deg)", fill: "#333333" }} />
              </IconButton>
            </Tooltip>
          )}
          {params.row.userStatus !== "INVITED" &&
            !isDeletedUserClicked.current &&
            (params.row.userStatus !== "PENDING_REVIEW" ||
              CommonService.isUser()) && (
              <Tooltip title="View user" arrow>
                <IconButton onClick={() => handleProfile(params.row.id)}>
                  <VisibilityOutlined />
                </IconButton>
              </Tooltip>
            )}
            {(params.row.roleName !== Constant.Role.SUPER_ADMIN && !CommonService.isUser()) && 
              isActiveUserClicked.current && !isDeletedUserClicked.current && 
              !isRejectedUserClicked.current && !isNeedReviewClicked.current && (
              <Tooltip title="Impersonate this Account" arrow>
              <IconButton onClick={() => handleLoginUserRowClick(params)}>
                 <img
                    src={LoginAsUserIcon}
                    className="cursor-pointer"
                    alt="LoginAsUserIcon"
                  />
              </IconButton>
            </Tooltip>
            )}
            
   {params.row.userStatus === "INVITED"  && (
            !isDeletedUserClicked.current && (
            // <IconButton onClick={(event) => handleResendClick(event, params)}>
            //     < SendOutlined />
            // </IconButton>
            <SingleReInvite
              reInvitedUser={params.row.email}
              companyId={params.row.companyId}
            />
    ))}
          {params.row.userStatus === "PENDING_REVIEW" &&
          !isDeletedUserClicked.current &&
            CommonService.isAdmin() && (
              // <IconButton onClick={(event) => handleApproveClick(event, params)}>
              //                         <FontAwesomeIcon icon={faUserCheck} />
              //                     </IconButton>
              <SingleApprove
                approveUser={[params.row]}
                displayIcon={true}
                reloadTable={reloadTable}
              />
            )}
          {params.row.userStatus === "PENDING_REVIEW" &&
          !isDeletedUserClicked.current &&
            CommonService.isAdmin() && (
              // <IconButton onClick={(event) => handleRejectClick(event, params)}>
              //     <FontAwesomeIcon icon={faUserTimes} />
              // </IconButton>
              <SingleReject
                rejectUser={[params.row]}
                displayIcon={true}
                reloadTable={reloadTable}
              />
            )}
               </div>
      ),
    },
  ];

  const userStatusColumn: GridColDef = {
    field: "userStatus",
    headerName: "Status",
    flex: 1,
    minWidth: 200,
    headerClassName: "table-header",
    renderCell: (params) => (
      <div>
        <StatusDropdown
          currentStatus={params.row.userStatus}
          onStatusChange={(newStatus) => {}}
          disableCondition={CommonService.isUser() || CommonService.isAdmin()}
          allowedLabels={[]}
        />
        {params.row.userStatus === "REJECTED" && (
          <Tooltip title={`Rejection Note: ${params.row.rejectionNote}`} arrow>
            <StickyNote2Icon
              className="note-icon cursor-pointer"
              style={{ color: "gray" }}
            />
          </Tooltip>
        )}
      </div>
    ),
  };

  // const columns: GridColDef[] = [
  //   ...commonColumns,
  //   ...(isNeedReviewClicked.current ? conditionalColumns : []),
  // ];

  const fetchWantedToBuyNotificationsToggleValue = async (usedId) => {
      try {
        setSelectedUserId(usedId);
        const response = await Service.getWantedToBuyNotificationToggleValueForUser(usedId);
        setToggleNotification(response?.data);
        setShow(true);
      } catch (error) {
        console.log("Error occurring while fetching all notifications", error);
      }
  };

  const saveWantedToBuyNotificationToggleValueForUser = async () => {
    try {
      const response = await Service.saveWantedToBuyNotificationToggleValueForUser(selectedUserId, toggleNotification);
      setToggleNotification(response?.data);
      setShow(false);
      CommonService.Toast.fire({
        title:"Setting updated successfully",
        icon: "success"
      });
    } catch (error) {
      console.log("Error occurring while fetching all notifications", error);
      CommonService.Toast.fire({
        title:"There is some issue occurred while saving notification settings!",
        icon: "error"
      });
    }
  };

  const columns: GridColDef[] = useMemo(() => {
    if (isRejectedUserClicked.current || isNeedReviewClicked.current) {
      // Insert the userStatus column after the "location" column
      const locationIndex = commonColumns.findIndex(
        (col) => col.field === "location"
      );
      if (locationIndex !== -1) {
        return [
          ...commonColumns.slice(0, locationIndex + 1),
          userStatusColumn,
          ...commonColumns.slice(locationIndex + 1),
        ];
      }
    }

    return commonColumns;
  }, [isNeedReviewClicked.current, isRejectedUserClicked.current]);

  const handleRowClick = (params) => {

    //row clickable only when status is not invited and pending_review
    if (isDeletedUserClicked.current && params.row.isCompanyDeleted === true) {
      // if (selectionModel.length <= 0) {
        let singleSelectedRow = [];
        singleSelectedRow.push(params.row);
        setIsSingleClickMode(true);
        setSelectedRowsFromTable(singleSelectedRow);
      // } else setIsSingleClickMode(false);
      setForceOpen(true);
    } else if (params.row.userStatus !== "INVITED" && params.row.isCompanyDeleted === true)
      handleProfile(params.row.id);
  };

  /**
   * Handles user row selection for impersonation.
   *
   * Requests an impersonation token for the selected user
   * and updates the client authentication state accordingly.
   */
  const handleLoginUserRowClick = async (params: any) => {
    try {

      // Resolve selected user identifier
      const userId = params?.row?.id;
      if (!userId) return;

      // Preserve current admin authentication details
      const adminToken = CookieService.getCookie("authToken");
      if (adminToken) {
        localStorage.setItem("adminTokenBackup", adminToken);
        localStorage.setItem("adminUserBackup", JSON.stringify({
          userName: CookieService.getCookie("userName"),
          userId: CookieService.getCookie("userId"),
          role: CookieService.getCookie("userRole"),
          companyId: CookieService.getCookie("companyId"),
          companyName: CookieService.getCookie("companyName")
        }));
      }

      // Request impersonation reference from backend
      const switchKeyResp = await Service.createImpersonationSwitchKey(userId);
      const switchKey = switchKeyResp?.data?.switchKey;
      if (!switchKey) {
        console.error("No switchKey returned");
        return;
      }

      // Exchange reference for impersonated authentication token
      const tokenResp = await Service.getImpersonationToken(switchKey);
      const { token, claims } = tokenResp.data;

      if (!token) {
        console.error("No token returned from impersonation token API");
        return;
      }

      // Apply impersonated authentication token
      CookieService.setAuthToken("authToken", token);

      // Store impersonated user details for application state
      CookieService.setAuthToken("userRole", claims.roles || Constant.Role.USER);
      CookieService.setAuthToken("userId", claims.userId || "");
      CookieService.setAuthToken("userName", claims.userName || "");
      CookieService.setAuthToken("companyId", claims.companyId || "");
      CookieService.setAuthToken("companyName", claims.companyName || "");

      // Update local UI and preference state
      localStorage.setItem("dashboardPrefrence", Constant.Profile.OWNER);
      localStorage.setItem("syncType", Constant.SyncType.KEGHOUND_TO_WHITEDOG);
      localStorage.setItem("showAssociatedCompany", "no");
      localStorage.setItem("loginAsUser", "yes");
      localStorage.removeItem("profile");

      // Persist impersonation context for later reference
      localStorage.setItem("impersonatedUser", JSON.stringify(claims));

      // Navigate based on impersonated role
      if (claims.roles === Constant.Role.SUPER_ADMIN) {
        history.push("master/dashboard");
      } else if (claims.roles === Constant.Role.ADMIN || claims.roles === Constant.Role.USER) {
        notificationWebSocketService.connect(claims.userId);
        history.push("/user/inventories");
      } else if (claims.roles === Constant.Role.WAREHOUSE) {
        notificationWebSocketService.connect(claims.userId);
        history.push("/master/storage-dashboard");
      }
    } catch (error) {
      console.error("Impersonation failed", error);
    }
  };

  const [selectionModel, setSelectionModel] = React.useState<GridRowId[]>([]);

  const handleSelectionModelChange = (newSelection: GridRowId[]) => {
    setSelectionModel(newSelection);
    const newSelectedRows = newSelection.map((id: GridRowId) => {
      return tableData.find((row: any) => row.id === id); // Assuming each row object has an 'id' property
    });
    setSelectionRowsFromTable(newSelectedRows);
    selectedRows.current = newSelectedRows;
    let flag: any = false;
    flag = selectedRows.current.some((user) => user.userStatus === "INVITED");
    disableAction.current = flag;
  };

  const [isLoading, setIsLoading] = useState(false);
  // Define the localeText object based on the isLoading flag
  const localeText = {
    noRowsLabel: isLoading ? "Fetching records ..." : "No Record Found",
  };

  // Filter rows based on search query
  // const filteredRows = tableData?.filter(
  //   (row) =>
  //     row.email?.toLowerCase().includes(search?.toLowerCase()) ||
  //     row.companyName?.toLowerCase().includes(search?.toLowerCase()) ||
  //     row.firstName?.toLowerCase().includes(search?.toLowerCase()) ||
  //     row.lastName?.toLowerCase().includes(search?.toLowerCase()) ||
  //     row.phoneNumber?.toLowerCase().includes(search?.toLowerCase()) ||
  //     (row.firstName + " " + row.lastName)
  //       .toLowerCase()
  //       .includes(search?.toLowerCase())
  // );

  // Map filtered rows with unique IDs
  const tableDataWithIds = tableData?.map((rowData, index) => ({
    ...rowData,
  }));

  //redirect to the profile page
  const handleProfile = (id: any) => {
    CommonService.isAdmin()
      ? history.push("/master/user-detail/" + id)
      : history.push("/user/user-detail/" + id);
  };

  const handleBack = () => {
    if (currentPath.startsWith("/master/my-warehouse/user-list/")) {
      history.push(`/master/company-dashboard/` + id);
    } else history.push(`/master/dashboard`);
  };

  const onPaginationModelChange = (newPaginationModel) => {
    setPage(newPaginationModel.page);
    setPageSize(newPaginationModel.pageSize);

    if (isActiveUserClicked.current) {
      fetchApprovedUserData(newPaginationModel.page, newPaginationModel.pageSize, filter, sortField, sortDirection);
    } else if (isDeletedUserClicked.current) {
      fetchDeletedUserData(newPaginationModel.page, newPaginationModel.pageSize, filter, sortField, sortDirection);
    } else if (isRejectedUserClicked.current) {
      showRejectedUsers(true, newPaginationModel.page, newPaginationModel.pageSize, filter, sortField, sortDirection);
    } else if (isNeedReviewClicked.current) {
      showSubmittedAndInvitedUsers(true, newPaginationModel.page, newPaginationModel.pageSize, filter, sortField, sortDirection);
    }
  };

  const handleSortChange = (sortModel) => {
    if (sortModel.length > 0) {
        const newSortField = sortModel[0].field;
        const newSortDirection = sortModel[0].sort; // "asc" or "desc" directly from DataGrid
        
        setSortField(newSortField);
        setSortDirection(newSortDirection);
    
        if (isActiveUserClicked.current) {
          fetchApprovedUserData(page, pageSize, filter, newSortField, newSortDirection);
        } else if (isDeletedUserClicked.current) {
          fetchDeletedUserData(page, pageSize, filter, newSortField, newSortDirection);
        } else if (isRejectedUserClicked.current) {
          showRejectedUsers(true, page, pageSize, filter, newSortField, newSortDirection);
        } else if (isNeedReviewClicked.current) {
          showSubmittedAndInvitedUsers(true, page, pageSize, filter, newSortField, newSortDirection);
        }
    }
  };

  return (
    <>
      <div className="usersList userList-wrapper">
        <div className="usersList__header--wrapper d-flex flex-wrap justify-content-between align-items-center gap-2">
        <div className="d-flex align-items-center flex-wrap gap-2">
          {CommonService.isAdmin() && (
            <IconButton
              onClick={handleBack}
              aria-label="ArrowBackIcon"
              sx={{
                backgroundColor: "#FFF",
                mb: 1,
                "&:hover": { backgroundColor: "#FFF" },
              }}
            >
              <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
            </IconButton>
          )}
          
          {CommonService.isAdmin() && (
            <>
              <div className="header--title mb-2">
                <h1 className="title mb-0">
                  Users <i className="bi bi-heart-fill"></i>
                </h1>
              </div>

              <div className="divider mx-2"></div>
              <InviteUser reloadTable={reloadTable} />
            </>
          )}
            
          {(CommonService.isAdmin() || CommonService.getRole() === Constant.Role.ADMIN) && (
              <button
                className="primary-btn d-inline-flex"
                onClick={handleAddUser}
              >
                <AddSharpIcon />
                Add User
              </button>
          )}

          </div>
          <div className="header--menu ms-auto">
            <div className="header--menu-items row d-flex">
              {/* <div className="col-auto input-container menu-items__search d-inline-flex mb-2 position-relative">
                    <input type="search" id="gsearch" name="gsearch" />
                    <img src={SearchIcon} alt="SearchIcon" className="icon position-absolute top-50 start-50 translate-middle" />
                </div> */}

              {/* <input placeholder="Search something..." className="input" name="text" type="text"></input> */}
               {/* {selectionModel.length > 0 && !isDeletedUserClicked.current && !isRejectedUserClicked.current && ( 
              <div className="col-auto mb-2">
                <DeleteUser deleteUser={selectionModel} reloadTable={reloadTable} isHardDeleteUser = {isNeedReviewClicked.current}/>
                <SearchBar search={search} setSearch={setSearch} />
              </div>
             )}  */}
              {/* <img src="../images/img_vert_line.svg" alt="vertline_one" className="h-[35px] md:w-full" /> */}
              
              <div className="col-auto menu-items__btnGroup btnGroup-border d-inline-flexflex-wrap gap-2 border-0">
              
                {/* {CommonService.isAdmin() && (
                  <InviteUser reloadTable={reloadTable} />
                )}

                <button
                  className="primary-btn d-inline-flex"
                  onClick={handleAddUser}
                >
                  <AddSharpIcon />
                  Add User
                </button> */}

                <div
                  className="btn-group user-activity-btn-grp flex-wrap"
                  role="group"
                  aria-label="Basic mixed styles example"
                >
                  <button
                    className={`tab-btn d-inline-flex justify-content-between align-items-center ${
                      isActiveUserClicked.current ? "bg-theme" : "bg-theme-white"
                    }`}
                    onClick={() => {
                      showActiveUsers(false);
                    }}
                  >
                    Active
                    <span
                      className={`review--number d-inline-flex align-items-center justify-content-center rounded-circle ms-2 ${
                        isActiveUserClicked.current
                          ? "bg-theme-white"
                          : "bg-theme"
                      }`}
                    >
                      {activeUserCount}
                    </span>
                  </button>

                  <button
                    className={`tab-btn d-inline-flex justify-content-between align-items-center ${
                      isDeletedUserClicked.current ? "bg-theme" : "bg-theme-white"
                    }`}
                    onClick={() => {
                      showDeletedUsers(false);
                    }}
                  >
                    Deleted
                    <span
                      className={`review--number d-inline-flex align-items-center justify-content-center rounded-circle ms-2 ${
                        isDeletedUserClicked.current
                          ? "bg-theme-white"
                          : "bg-theme"
                      }`}
                    >
                      {deleteUserCount}
                    </span>
                  </button>

                  <button
                    className={`tab-btn d-inline-flex justify-content-between align-items-center  ${
                      isNeedReviewClicked.current ? "bg-theme" : "bg-theme-white"
                    }`}
                    onClick={() => {
                      showSubmittedAndInvitedUsers(false, page, pageSize, filter, sortField, sortDirection);
                    } }
                  >
                    {CommonService.isAdmin() ? "Need Review" : "Pending"}
                    <span
                      className={`review--number d-inline-flex align-items-center justify-content-center rounded-circle ms-2 ${
                        isNeedReviewClicked.current
                          ? "bg-theme-white"
                          : "bg-theme"
                      }`}
                    >
                      {reviewUserCount}
                    </span>
                  </button>

                  <button
                    className={`tab-btn d-inline-flex justify-content-between align-items-center  ${
                      isRejectedUserClicked.current ? "bg-theme" : "bg-theme-white"
                    }`}
                    onClick={() => {
                      showRejectedUsers(false, page, pageSize, filter, sortField, sortDirection);
                    } }
                  >
                    Rejected
                    <span
                      className={`review--number d-inline-flex align-items-center justify-content-center rounded-circle ms-2 ${
                        isRejectedUserClicked.current
                          ? "bg-theme-white"
                          : "bg-theme"
                      }`}
                    >
                      {rejectedUsersCount}
                    </span>
                  </button>
                </div>
              </div>
              {/* {CommonService.isAdmin() &&
                tableDataWithIds?.length > 0 &&
                (isRejectedUserClicked.current ||
                  isActiveUserClicked.current ||
                  isNeedReviewClicked.current) && (
                  <>
                    
                  </>
                )} */}

              {/* {CommonService.isAdmin() &&
                tableDataWithIds?.length > 0 &&
                isDeletedUserClicked.current && (
                  <>
                    <div className="col-auto menu-items__btnGroup d-inline-flex mb-2">
                      <RestoreUser
                        openPopUp={forceOpen}
                        isSingleClickMode={isSingleClickMode}
                        selectionModel={selectionRowsFromTable}
                        restoreUser={selectedRowsFromTable}
                        reloadTable={reloadTable}
                        setOpenPopUp={setOpenPopUp}
                      />
                    </div>
                  </>
                )} */}
            </div>
            </div>
            <div className={`action-wrapper text-end ${!CommonService.isAdmin() && 'user-action-wrapper'}`}>
              {selectionModel.length > 0 && !isDeletedUserClicked.current && !isRejectedUserClicked.current && ( 
              <div className=" mb-2">
                <DeleteUser deleteUser={selectionModel} reloadTable={reloadTable} isHardDeleteUser = {isNeedReviewClicked.current}/>
                {/* <SearchBar search={search} setSearch={setSearch} /> */}
              </div>
             )} 
             {CommonService.isAdmin() &&
                tableDataWithIds?.length > 0 &&
                isDeletedUserClicked.current && (
                  <>
                    <div className="col-auto menu-items__btnGroup d-inline-flex mb-2">
                      <RestoreUser
                        openPopUp={forceOpen}
                        isSingleClickMode={isSingleClickMode}
                        selectionModel={selectionRowsFromTable}
                        restoreUser={selectedRowsFromTable}
                        reloadTable={reloadTable}
                        setOpenPopUp={setOpenPopUp}
                      />
                    </div>
                  </>
                )}
            </div>
          
        </div>
      <div className="user-table-container">
        <div className="userTable">
          <DataGrid
            rows={tableDataWithIds}
            columns={commonColumns}
            className="data-grid"
             isRowSelectable={(params) =>
              !(
                isDeletedUserClicked.current &&
                params.row.isCompanyDeleted === false
              )
            }
            initialState={{
              pagination: {
                  paginationModel: { page, pageSize },
              },
            }}
            pagination
            paginationModel={{page, pageSize }}
            paginationMode="server"
            sortingMode="server"
            disableRowSelectionOnClick={true}
            rowCount={totalCount}
            pageSizeOptions={[10, 20, 50, 100]}
            localeText={localeText}
            checkboxSelection
            rowSelectionModel={selectionModel}
            onSortModelChange={handleSortChange}
            onPaginationModelChange={onPaginationModelChange}
            onRowSelectionModelChange={handleSelectionModelChange}
            onRowClick={handleRowClick}
            loading={isLoading} 
            slots={{
              loadingOverlay: DataGridLoader,
            }}
            sx={{
              "& .MuiDataGrid-columnHeaderCheckbox": {
                borderBottom: "unset !important"
              },
            }}/>
        </div>
      </div>
    </div>
    <Modal
            
            show={show}
            onHide={handleClose}
            className="modal__wd modal__inviteUser modal__wd--submitSellReq"
          >
            <Modal.Header
              className="flex-column align-items-start"
              style={{ marginBottom: "0px" }}
            >
              <Modal.Title>
                Manage Notifications
              </Modal.Title>
            </Modal.Header>
              <Modal.Body className="border-0">
                <div className='notification-toggle-wrapper'>
              <div className="d-flex align-items-center">
                <label className="toggle-switch d-flex align-items-center justify-content-between w-100">
                  <input
                    type="checkbox"
                    checked={toggleNotification}
                    onChange={handleNotificationToggle}
                  />
                  <span className='switch-label' style={{fontSize:"18px"}}>
                    Wanted To Buy
                  </span>
                  <div className='switch-inner' style={{
                    backgroundColor: toggleNotification ? '#9E874A' : 'transparent',
                    borderColor: toggleNotification ? '#9E874A' : '#DEE2E6',
                  }}>
                    <div className='switch-toggler' style={{
                      left: toggleNotification ? '22px' : '2px',
                      backgroundColor: toggleNotification ? '#fff' : '#BFBFBF',
                    }} />
                  </div>
                </label>
              </div>
            </div>
              </Modal.Body>

              <Modal.Footer className="justify-content-center pt-0">
            <hr className="dropdown-divider w-100" style={{background:"#D9D9D9", marginInline:"18px", marginBottom:"20px", height:"1px"}}></hr>
                <div className="btn-group d-flex justify-content-center w-100 gap-2 mx-3">
                    <button className="secondary-btn w-100" onClick={handleClose}>
                      Close
                    </button>
                    <button className="primary-btn w-100" onClick={saveWantedToBuyNotificationToggleValueForUser}>
                      Update
                    </button>
                </div>
              </Modal.Footer>
          </Modal>
    </>
  );
};

export default UserList;
